<template>
  <div class="flex-1 flex flex-middle flex-column con">
    <el-date-picker
      v-model="dateRange"
      value-format="yyyy-MM-dd HH:mm:ss"
      type="datetimerange"
      size="mini"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="dateTimeChange"
    >
    </el-date-picker>
    <div :id="id" class="line-box" />
  </div>
</template>
<script>
import * as echarts from "echarts";
import resize from "@/utils/resize";

export default {
  mixins: [resize],
  props: {
    chartData: {
      default: () => {},
      type: Object,
    },
    id: {
      default: "lineChart",
      type: String,
    },
    dataActive: {
      default: 0,
      type: Number,
    },
    refresh: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      chart: null,
      times: [],
      dateRange: [],
    };
  },
  watch: {
    refresh: {
      handler() {
        if (this.refresh === 0) return;
        this.dateRange = this.chartData.dateRange;
        this.initChart();
      },
      immediate: true,
    },
  },

  methods: {
    dateTimeChange(range) {
      this.$emit("dateTimeChange", range);
    },
    initChart() {
      const dom = document.getElementById(this.id);
      if (!dom) return;
      this.chart = echarts.init(dom);
      const yAxis = [];
      const series = [];
      for (let i = 0; i < this.chartData.units.length; i++) {
        const leftBottomOffsetStep =
          this.id === "lineChart2"
            ? i % 2 === 0
              ? i * 30
              : 0
            : i % 2 === 0
            ? i * 25
            : (i - 1) * 25;
        console.log("leftBottomOffsetStep", this.id, leftBottomOffsetStep, i);
        /*this.dataActive === 0
            ? this.id === "lineChart2"
              ? i % 2 === 0
                ? i * 30
                : i * 25
              : i * 20
            : this.id === "lineChart2"
            ? i % 2 === 0
              ? i * 28
              : i * 25
            : i * 20;*/
        yAxis.push({
          type: "value",
          splitNumber: 5,
          offset: leftBottomOffsetStep,
          position: i % 2 === 0 ? "left" : "right",
          axisLabel: {
            formatter: "{value}" + this.chartData.units[i],
            textStyle: {
              color: "#EEEEEE",
              fontStyle: "normal",
              fontFamily: "微软雅黑",
              fontSize: 10,
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EEEEEE",
              opacity: 0.3,
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(202, 255, 253, 0.2)",
              opacity: 0.3,
            },
          },
        });
      }
      for (let i = 0; i < this.chartData.names.length; i++) {
        const unit = this.chartData.nameUnits[i];
        series.push({
          name: this.chartData.names[i],
          yAxisIndex: this.chartData.units.indexOf(unit),
          type: "line",
          // smooth: true,
          symbol: "none",
          // symbolSize: 10,
          itemStyle: {
            normal: {
              color: this.chartData.colors[i],
              shadowColor: this.chartData.colors[i],
              shadowBlur: 20,
              borderColor: this.chartData.colors[i],
              borderWidth: 2,
              lineStyle: {
                color: this.chartData.colors[i],
                width: 1.2,
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 255, 0)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.2)",
                  },
                ]),
              },
            },
          },
          data: this.chartData.datas[i],
        });
      }
      const formatterStr = () => {
        let str = "{b}<br />";
        this.chartData.nameUnits.forEach((unit, index) => {
          str += `{a${index}}: {c${index}}${unit}<br />`;
        });
        return str;
      };
      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "axis",
          formatter: formatterStr(),
        },
        grid: {
          left: "2%",
          right: "6%",
          bottom: this.id === "lineChart1" ? "12%" : "15%",
          height: "80%",
          containLabel: true,
        },
        legend: {
          data: this.chartData.names,
          bottom: "0%",
          textStyle: {
            color: "rgba(255,255,255,0.8)",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false, // 坐标轴两边留白
          data: this.chartData.times,
          axisLabel: {
            // 坐标轴刻度标签的相关设置。
            // interval: 5, // 设置为 1，表示『隔一个标签显示一个标签』
            textStyle: {
              color: "#eeeeee",
              fontStyle: "normal",
              fontFamily: "微软雅黑",
              fontSize: 12,
            },
          },
          axisTick: {
            // 坐标轴刻度相关设置。
            show: false,
          },
          axisLine: {
            // 坐标轴轴线相关设置
            lineStyle: {
              color: "#CAFFFD",
              opacity: 0.3,
            },
          },
          splitLine: {
            // 坐标轴在 grid 区域中的分隔线。
            show: false,
            lineStyle: {
              color: "#E5E9ED",
              // 	opacity:0.1
            },
          },
        },
        yAxis,
        series,
      };

      this.chart.setOption(option, true);
    },
    timeArray(length) {
      const startTime = new Date(2024, 9, 31, 16, 22); // 注意：月份是从0开始计数的，所以10月是9
      // 时间间隔，以毫秒为单位 (15分钟 = 15 * 60 * 1000 毫秒)
      const interval = 15 * 60 * 1000;
      // 生成时间数组
      const timeArray = Array.from({ length }, (_, i) => {
        const date = new Date(startTime.getTime() + i * interval);
        return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(
          2,
          "0"
        )}/${String(date.getDate()).padStart(2, "0")} ${String(
          date.getHours()
        ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
      });
      return timeArray;
    },
    generateRandomArray(n, [min, max], decimalPlaces) {
      return Array.from({ length: n }, () =>
        (Math.random() * (max - min) + min).toFixed(decimalPlaces)
      );
    },
  },
};
</script>

<style scoped lang="scss">
.con {
  padding: calc(100vh / 1080 * 20) 5px 0;
}
::v-deep .el-date-editor {
  width: 320px;
  &.el-input__inner {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.2);
    .el-range-input {
      background: transparent;
      color: rgba(255, 255, 255, 0.8);
    }
    .el-range-separator {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
.line-box {
  width: 100%;
  height: calc(100% - 40px);
}
</style>
